module.exports = __webpack_public_path__ + "img/slider-11.8227588f.jpg";